<template>
    <div>
        <div class="select-address highlight padding15" v-show="hideForm">
            <div class="right">
                <!-- <a href="" :id="selAddr.ID" class="small">{{ labels[1001] }} edit -></a> -->
            </div>
            <div v-html="breakCharsToBr(selAddr.ADDRESS)"></div>
            {{ selAddr.address1 }} {{ selAddr.CITY }}, {{ selAddr.STATE }} {{ selAddr.POSTAL }}
            <br />
            {{ selAddr.COUNTRY }}
            <br /><br />
            <template v-if="isShippingAddr">
                <em>{{ labels[1383] }}</em><!-- label: Attention: -->
                <br />
                <div v-if="selAddr.ATTNNAME.length">
                    {{ selAddr.ATTNNAME }}
                </div>
                <div v-else>
                    <a href="" @click.prevent="openAndFocus('attnNameRef')" class="small">{{ labels[1682] }}</a><!-- label: add name -->
                </div>
                <div v-if="selAddr.ATTNPHONE.length">
                    {{ selAddr.ATTNPHONE }}
                </div>
                <div v-else>
                    <a href="" @click.prevent="openAndFocus('attnPhoneRef')" class="small">{{ labels[1685] }}</a><!-- label: add phone -->
                </div>
            </template>
        </div>
        <!-- <input type="hidden" name="validAddress" id="validAddress" v-model="selAddr.VALID" /> -->
        <div v-show="!hideForm">
        <br />
        <h4 v-if="isNewAddr">
            {{ labels[1045] }}<!-- Enter a new address: -->
        </h4>
        <form name="newAddy" id="newAddyVue" @submit.prevent="submitAddress" class="std nostripes">
            <div v-if="hasErrors && displayErrors" id="newAddy-errors-vue" class="errorMsg">
                {{ labels[1046] }}<!-- Please fix the below errors before continuing: -->
            </div>
            <table class="table table-condensed table-striped">
                <tbody id="ctry">
                    <tr>
                        <td>
                            {{ labels[87] }}*<!-- Country - shared-->
                        </td>
                        <td>
                            <select name="country" id="country" v-model="selAddr.COUNTRY" @change="countryChange" class="newAddy form-control" required :disabled="selAddr.VALID">
                                <option value="">{{ labels[579] }}</option><!-- label: Select Your Country -->
                                <template v-for="c in countries" >
                                    <option v-bind:key="c.name" :value="c.name">
                                        {{ c.name }}
                                    </option>
                                </template>
                            </select>
                            <label v-if="!selAddr.COUNTRY && displayErrors" class="errorMsg">{{ labels[713] }}</label><!-- label: Country is required -->
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="isShippingAddr && !selAddr.COUNTRY" id="shipNoteVue">
                    <tr>
                        <td colspan="2">
                            <div class="infoText" v-html="labels[1047]"></div><!-- <strong>Note:</strong> Due to our international distribution agreements, orders can only be shipped to countries supported by Campbell Scientific, Inc.
                            Contact us at <a href="mailto:orders@campbellsci.com">orders@campbellsci.com</a> for questions. -->
                        </td>
                    </tr>
                </tbody>
                <tbody id="addFormBodyVue" v-if="selAddr.COUNTRY">
                    <tr>
                        <td>
                            {{ labels[480] }}*<!-- Street Address -->
                        </td>
                        <td>
                            <input type="text" id="address2" name="address2" class="newAddy form-control" v-model="addressLines.address2" required :disabled="selAddr.VALID"/>
                            <label v-if="!addressLines.address2 && displayErrors" class="errorMsg">{{ labels[1050] }}</label><!-- label: Street address is Required -->
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><input type="text" id="address3" name="address3" class="newAddy form-control" v-model="addressLines.address3" :disabled="selAddr.VALID"/></td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><input type="text" id="address4" name="address4" class="newAddy form-control" v-model="addressLines.address4" :disabled="selAddr.VALID"/></td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><input type="text" id="address5" name="address5" class="newAddy form-control" v-model="addressLines.address5" :disabled="selAddr.VALID"/></td>
                    </tr>
                    <tr>
                        <td>
                            {{ labels[456] }}*<!-- City -->
                        </td>
                        <td>
                            <input type="text" id="city" name="city" class="newAddy form-control" v-model="selAddr.CITY" required :disabled="selAddr.VALID"/>
                            <label v-if="!selAddr.CITY && displayErrors" class="errorMsg">{{ labels[707] }}</label><!-- label: City is required -->
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ labels[708] }}*<!-- State/Province -->
                        </td>
                        <td>
                            <select class="form-control newAddy" v-model="selAddr.STATE" v-if="states.length" name="state" id="stateselvue" required :disabled="selAddr.VALID">
                                <option value="">Select a state</option><!-- label: state -->
                                <!-- <template > --> <!-- todo vue3 -->
                                    <option v-for="state in states" v-bind:key="state.code" :value="state.code" :selected="selAddr.STATE === state.code || selAddr.STATE === state.name">
                                        {{ state.name }}
                                    </option>
                                <!-- </template> -->
                            </select>
                            <input class="form-control w50" v-if="!states.length" :disabled="states.length" type="text" name="state" id="stateinvue" v-model="selAddr.STATE" required />
                            <label v-if="!selAddr.STATE && displayErrors" class="errorMsg">{{ labels[717] }}</label><!-- label: State/Province is required -->
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ labels[710] }}*<!-- Zip/Postal -->
                        </td>
                        <td>
                            <input type="text" name="postal" class="newAddy form-control" v-model="selAddr.POSTAL" required :disabled="selAddr.VALID"/>
                            <label v-if="!selAddr.POSTAL && displayErrors" class="errorMsg">{{ labels[718] }}</label><!-- label: Postal/Zip code is required -->
                        </td>
                    </tr>
                    <template v-if="isShippingAddr">
                        <tr>
                            <td>
                                {{ labels[1332] }} <!--Attention-->
                            </td>
                            <td>
                                <input type="text" id="attnname" name="attnname" ref="attnNameRef" class="newAddy form-control" v-model="selAddr.ATTNNAME" autofocus />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{ labels[1333] }} <!--Attention-->
                            </td>
                            <td>
                                <input type="text" id="attnphone" name="attnphone" ref="attnPhoneRef" class="newAddy form-control" v-model="selAddr.ATTNPHONE" />
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td></td>
                        <td>
                            <small>{{ labels[1309] }}<!-- * = required --></small>
                            <span class="right">
                                <a href="#" id="cancel-add-new-vue" @click.prevent="cancelAddNew">{{ labels[1030] }}<!-- cancel --></a>&nbsp;&nbsp;
                                <button type="submit" class="btn btn-default save-addr-vue" :disabled="hasErrors">{{ labels[1028] }}<!-- Save --></button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
    </div>
</template>

<script>
import { computed, reactive } from '@vue/composition-api';
import useAlerts from '../../shared/composables/useAlerts'
import useCMS from "../../shared/composables/useCMS"
import useGeo from "../../shared/composables/useGeo"
import useCheckout from "../composables/useCheckout"
import useCheckoutAddresses from "../composables/useCheckoutAddresses"
import useUtils from "../../shared/composables/useUtils"

export default {
    name: 'CheckoutAddressForm',
    props: {
        mode: {
            validator: function(value) {
                return ['billing','shipping'].indexOf(value) !== -1;
            }
        }
    },
    setup (props) {
        const { labels } = useCMS();
        const { addresses } = useCheckout();
        const { breakApartAddress } = useCheckoutAddresses();
        const { breakCharsToBr } = useUtils();

        const isShippingAddr = computed(() => props.mode === 'shipping');
        const selAddr = computed(() => addresses.value[props.mode]);
        const addressLines = reactive(breakApartAddress(selAddr.value.ADDRESS));

        const { countryChange, stateOptions, siteCountries } = useFormGeo(selAddr);
        const { isNewAddr, hideForm, openEditAddress, submitAddress, cancelAddNew, hasErrors } = useFormActionsChecks(selAddr, addressLines, props.mode);
        const displayErrors = computed(() => {
            return selAddr.value.ID != 'new' && selAddr.value.ID != 0
        });

        return {
            labels,
            states: stateOptions,
            countries: siteCountries,
            addressLines,
            selAddr,
            submitAddress,
            isShippingAddr,
            cancelAddNew,
            hasErrors,
            hideForm,
            isNewAddr,
            countryChange,
            openEditAddress,
            breakCharsToBr,
            displayErrors
        }
    },
    methods: {
        openAndFocus: function(input){
            //$refs is only available after mounted, not in setup
            this.openEditAddress(this.$refs[input]);
        }
    }
}

function useFormActionsChecks(selAddr, addressLines, mode) {
    const { editingAddress, saveAddress, revertToDefaultAddress } = useCheckoutAddresses();

    const isNewAddr = computed(() => selAddr.value.ID === 'new');
    const hideForm = computed(() => !isNewAddr.value && !editingAddress.value && selAddr.value.VALID);

    const openEditAddress = (focusEl) => {
        editingAddress.value = true;
        focusEl.focus(); //Not sure why this isn't focusing
    }

    const submitAddress = () => {
        if(!hasErrors.value){
            saveAddress(selAddr.value, addressLines, mode);
        }
    }

    const cancelAddNew = () => {
        editingAddress.value = false;
        revertToDefaultAddress(mode);
    }

    const hasErrors = computed(() => {
        return (
            !selAddr.value.COUNTRY
            || !selAddr.value.CITY
            || !selAddr.value.STATE
            || !selAddr.value.POSTAL
            || !addressLines.address2
        )
    });

    return {
        isNewAddr,
        hideForm,
        openEditAddress,
        submitAddress,
        cancelAddNew,
        hasErrors
    }
}

function useFormGeo(selAddr) {
    const { getStateOptions, stateOptions, getSiteCountries, siteCountries } = useGeo();
    const { addAlert } = useAlerts();

    if (!siteCountries.value.length) {
        getSiteCountries().then(function(){
            if(selAddr.value.COUNTRY){
                getStateOptions(selAddr.value.COUNTRY);
            }
        }).catch((error) => {
            addAlert('An error occurred loading address data.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const countryChange = () => {
        let selectedCountry = {};
        for (let i = 0; i < siteCountries.value.length; i++) {
            if (siteCountries.value[i].name == selAddr.value.COUNTRY) {
                selectedCountry = siteCountries.value[i];
                break;
            }
        }

        if (selectedCountry.id) {
            getStateOptions(selectedCountry.name);
        }

    }

    return {
        countryChange,
        stateOptions,
        siteCountries
    }
}

</script>

<style scoped>
    .errorMsg{
        color:#a60000;
        display:block;
    }
</style>
